import React from 'react';
import { useLocation } from 'react-router-dom';
import PricingRuleForm from './widgets/PricingRuleForm';

export default function AddPricingRuleScreen() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const unitIdRaw = params.get('shipment_unit');
  const unitId = unitIdRaw ? parseInt(unitIdRaw, 10) : null;
  const planIdRaw = params.get('plan');
  const planId = planIdRaw ? parseInt(planIdRaw, 10) : null;
  const unitContext =
    location.state?.unitContext ||
    (Number.isFinite(unitId)
      ? {
          id: unitId,
          serial_number: location.state?.serial_number ?? null,
        }
      : null);
  const planContext =
    location.state?.planContext ||
    (Number.isFinite(planId)
      ? {
          id: planId,
          code: location.state?.plan_code ?? null,
          name: location.state?.plan_name ?? null,
        }
      : null);
  const returnTo = location.state?.returnTo || null;

  return (
    <PricingRuleForm
      mode="create"
      unitContext={unitContext}
      planContext={planContext}
      returnTo={returnTo}
    />
  );
}
